import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import Translate from '../../components/translate/Translate';
import './EndMeeting.scss';

interface EndMeetingModalProps {
    ctrl: {
        isVisible: boolean;
        confirm: () => void;
        cancel: () => void;
        onHideHandler: () => void;
    };
}

const EndMeetingHeader = () => (
    <div className='modal-header'>
        <h3 className='modal-title'>
            <Translate text='END_MEETING.VIEW.TITLE' />
        </h3>
    </div>
);

const EndMeetingBody = () => (
    <div className='modal-body'>
        <p>
            <Translate text='END_MEETING.VIEW.BODY' />
        </p>
    </div>
);

const EndMeetingFooter = ({onConfirm, onCancel}: any) => (
    <div className='modal-footer'>
        <button className='btn btn-primary' onClick={onConfirm}>
            <Translate text='END_MEETING.VIEW.CONFIRM' />
        </button>
        <button className='btn btn-primary' onClick={onCancel}>
            <Translate text='END_MEETING.VIEW.CANCEL' />
        </button>
    </div>
);

@observer
export class EndMeetingModal extends TechseeBaseComponent<EndMeetingModalProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        return (
            <GenericModal
                className='end-meeting-modal'
                header={() => <EndMeetingHeader />}
                content={() => <EndMeetingBody />}
                toolbar={() => <EndMeetingFooter onConfirm={ctrl.confirm} onCancel={ctrl.cancel} />}
                onHideHandler={ctrl.onHideHandler}
                isCloseVisible={false}
                show={ctrl.isVisible}
            />
        );
    }
}
